import { Link } from 'react-router-dom';
import { animeCategories } from '@/mocks/anime';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-white text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-50">
                6080<span className="text-primary-500">影视</span>
              </span>
            </Link>
            <p className="text-foreground-500 text-sm leading-relaxed mb-4">
              动漫番剧免费高清在线观看平台，提供不缓冲流畅追番体验。海量免费动漫大全覆盖日漫、国漫、经典番剧。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-foreground-50 font-semibold mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-foreground-500 text-sm hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/all" className="text-foreground-500 text-sm hover:text-primary-400 transition-colors">动漫大全</Link></li>
              <li><Link to="/about" className="text-foreground-500 text-sm hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><a href="#faq" className="text-foreground-500 text-sm hover:text-primary-400 transition-colors">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-50 font-semibold mb-4">动漫分类</h4>
            <ul className="space-y-2.5">
              {animeCategories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-foreground-500 text-sm hover:text-primary-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-foreground-50 font-semibold mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-mail-line text-foreground-400"></i>
                <span>contact@6080ys.com</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-customer-service-line text-foreground-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-map-pin-line text-foreground-400"></i>
                <span>中国 · 深圳</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="container-custom py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-foreground-600 text-xs">
            &copy; {new Date().getFullYear()} 6080影视 - 版权所有 | 本站资源仅供学习交流，请勿用于商业用途
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}